import { render, staticRenderFns } from "./buyMs.vue?vue&type=template&id=4a0e82b1&scoped=true&"
import script from "./buyMs.vue?vue&type=script&lang=js&"
export * from "./buyMs.vue?vue&type=script&lang=js&"
import style0 from "./buyMs.vue?vue&type=style&index=0&id=4a0e82b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e82b1",
  null
  
)

export default component.exports